export const DEFAULT_MIN_LENGTH = 3;

export const meetsMinimumSearchLength = (
  inputValue: string,
  minSearchLength: number | undefined,
  parentCategorizationId: string | undefined,
  currentCategorizationId: string,
  parentCategoryValue: string | undefined,
): boolean => {
  const minLength =
    minSearchLength === undefined ? DEFAULT_MIN_LENGTH : minSearchLength;

  const isSelfReferencing = parentCategorizationId === currentCategorizationId;
  const inputMeetsMinLength = inputValue.length >= minLength;

  if (!isSelfReferencing || !parentCategoryValue || inputValue.length) {
    return inputMeetsMinLength;
  }

  return parentCategoryValue.length >= minLength;
};
